!customElements.get('po-pdp-status') && customElements.define("po-pdp-status", class PoPdpStatus extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;    
    this.pdpStatusData = JSON.parse(this.querySelector('#po-pdp-status').textContent);
  }

  connectedCallback() {
  
    subscribe(PUB_SUB_EVENTS.faceSizeSelection, (eventData) => {
      let newSelectedVariantId = eventData.data.variant.id;
      this.handlePdpStatusSelectedVariant(newSelectedVariantId);
    });
  }

  handlePdpStatusSelectedVariant(variantId) {
    const selectedVariant = this.pdpStatusData.non_rx_variants[variantId];

    if (selectedVariant) {
      this.handleUpdateStatus(selectedVariant);
    } else {
      console.warn(`Variant ${variantId} not found`);
    }
  }

  handleUpdateStatus(selectedVariant) {
    let statusElements = document.querySelectorAll('[data-pdp-status]');

    statusElements.forEach((element) => {
      element.setAttribute('data-pdp-status', selectedVariant.pdp_status);
    });
  }
});
